export default __webpack_public_path__ + "static/media/home.b4603e9e.svg";